import { Link } from "react-router-dom";
import { SITE_NAME } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-rule bg-paper">
      <div className="container-wide grid gap-10 py-14 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="font-serif text-[1.4rem] leading-none text-ink">
            {SITE_NAME}
          </div>
          <p className="mt-3 max-w-xs text-small text-charcoal/70">
            An editorial resource for patients researching smile-makeover
            clinics in Spain. A single rubric, applied consistently.
          </p>
          <p className="mt-5 max-w-xs text-xs text-charcoal/70">
            Spain Smile Guide is an editorial publication, not a medical
            directory. Nothing on this site is medical advice. Consult a
            qualified clinician before making treatment decisions.
          </p>
        </div>

        <nav aria-label="Guides" className="md:col-span-2">
          <div className="eyebrow mb-3">Guides</div>
          <ul className="space-y-2 text-small">
            <li>
              <Link to="/how-to-choose-a-smile-makeover-clinic-in-spain">
                How to choose a clinic
              </Link>
            </li>
            <li>
              <Link to="/natural-vs-overdone-veneers">
                Natural vs overdone veneers
              </Link>
            </li>
            <li>
              <Link to="/minimal-prep-vs-overprepped-veneers">
                Minimal-prep vs over-prepped
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Comparisons by city" className="md:col-span-2">
          <div className="eyebrow mb-3">Comparisons &middot; by city</div>
          <ul className="space-y-2 text-small">
            <li>
              <Link to="/best-smile-makeover-clinics-in-spain">
                National guide
              </Link>
            </li>
            <li>
              <Link to="/best-veneer-clinics-in-madrid">Madrid</Link>
            </li>
            <li>
              <Link to="/best-veneer-clinics-in-barcelona">Barcelona</Link>
            </li>
            <li>
              <Link to="/best-veneer-clinics-in-marbella">
                Marbella / Costa del Sol
              </Link>
            </li>
            <li>
              <Link to="/best-veneer-clinics-in-valencia">Valencia</Link>
            </li>
            <li>
              <Link to="/best-veneer-clinics-in-seville">Seville</Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Methodology" className="md:col-span-2">
          <div className="eyebrow mb-3">Methodology</div>
          <ul className="space-y-2 text-small">
            <li>
              <Link to="/methodology">The rubric</Link>
            </li>
            <li>
              <Link to="/how-porcelain-is-made">How porcelain is made</Link>
            </li>
            <li>
              <Link to="/reading-a-veneer-warranty">
                Reading a veneer warranty
              </Link>
            </li>
            <li>
              <Link to="/glossary">Glossary</Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="About" className="md:col-span-2">
          <div className="eyebrow mb-3">About</div>
          <ul className="space-y-2 text-small">
            <li>
              <Link to="/about">About &amp; disclosure</Link>
            </li>
            <li>
              <Link to="/editorial-standards">Editorial standards</Link>
            </li>
            <li>
              <Link to="/corrections">Corrections</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-rule">
        <div className="container-wide flex flex-col gap-2 py-5 text-xs text-charcoal/60 md:flex-row md:justify-between">
          <span>
            &copy; {year} {SITE_NAME}. Editorial, not commercial.
          </span>
          <span>
            Affiliated with ACE DNTL STUDIO — see{" "}
            <Link to="/about">About</Link>.
          </span>
        </div>
      </div>
    </footer>
  );
}
